import { useTranslation } from "react-i18next";
import { DaySelector } from "../../../../models/requests/IDaySelector";
import { IVlcportHistoricFilter } from "../../../../models/vlcPort/IHistoricRequest";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { updateVlcportHistoricFilterProperty, resetVlcportHistoricFilter } from "../../../../redux/reducers/vlcPort/historic/filter";
import { compileNameOfProperty } from "../../../../utils";
import { CustomDatePicker } from "../../../common/customDatePicker/customDatePicker";
import { FilterHeader } from "../../../common/filterHeader/filterHeader";
import { TextInput } from "../../../common/inputs/textInput";
import { BooleaMultiSelector } from "../../../common/selectors";
import { useTheme } from "react-jss";
import { VlcportHistoricFilterStyle } from "./filterStyle.jss";
import {
    fetchVlcportHistoricInspectionAppoiment,
    fetchVlcportHistoricInspectionResult,
    fetchVlcPortHistoricPositioningRequest,
} from "../../../../redux/actions/vlcPort/historic/historic";
import { VlcportHistoricListPivotId } from "../container";

interface IVlcportHistoricFilterProps {
    selectedPivot: string;
}

export const VlcportHistoricFilter: React.FC<IVlcportHistoricFilterProps> = ({ selectedPivot }) => {
    const dispatch = useAppDispatch();
    const { filter } = useAppSelector((state) => state.vlcportHistoricFilter);
    const { t } = useTranslation("common", { keyPrefix: "VLC_PORT.HISTORIC" });
    const theme = useTheme();
    const style = VlcportHistoricFilterStyle({ theme });

    const onApply = () => {
        selectedPivot === VlcportHistoricListPivotId.INSPECTIONAPPOINTMENT && dispatch(fetchVlcportHistoricInspectionAppoiment());
        selectedPivot === VlcportHistoricListPivotId.INSPECTIONRESULT && dispatch(fetchVlcportHistoricInspectionResult());
        selectedPivot === VlcportHistoricListPivotId.POSITIONINGREQUEST && dispatch(fetchVlcPortHistoricPositioningRequest());
    };

    const onReset = () => {
        dispatch(resetVlcportHistoricFilter());
        onApply();
    };

    const updateHeaderProperty = (name: string, value: any) => {
        dispatch(updateVlcportHistoricFilterProperty({ name, value }));
    };
    const onInputChange = (event: any, name: string) => {
        updateHeaderProperty(name, event.target.value);
    };
    const onBooleanSelectorChange = (name: string, nullablebooleanValue: any) => {
        updateHeaderProperty(name, nullablebooleanValue);
    };
    const content = (
        <div className={style.container}>
            <CustomDatePicker
                startDate={filter.startDate}
                endDate={filter.endDate}
                maxDaySelected={DaySelector.MAX_YEAR_SELECTED}
                minDaySelected={DaySelector.MIN_DAYS_SELECTED}
                setFilterProperty={updateHeaderProperty}
                showLeftArrowController={false}
            />
            <div className={style.verticalWhiteSeparator}></div>

            <div className={style.filter}>
                <div className={style.row}>
                    <div className={style.item}>
                        <TextInput
                            value={filter.fileName}
                            propertyName={compileNameOfProperty<IVlcportHistoricFilter>("fileName")}
                            label={t("FILE_NAME")}
                            onChange={onInputChange}
                            onEnter={onApply}
                        />
                    </div>
                    <div className={style.item}>
                        <TextInput
                            value={filter.integrationReference}
                            propertyName={compileNameOfProperty<IVlcportHistoricFilter>("integrationReference")}
                            label={t("REFERENCE")}
                            onChange={onInputChange}
                            onEnter={onApply}
                        />
                    </div>
                    <div className={style.item}>
                        <TextInput
                            value={filter.transportUnitNumber}
                            propertyName={compileNameOfProperty<IVlcportHistoricFilter>("transportUnitNumber")}
                            label={t("UTI_TRANSPORT_NUMBER")}
                            onChange={onInputChange}
                            onEnter={onApply}
                        />
                    </div>
                </div>
                <div className={style.row}>
                    <div className={style.item}>
                        <BooleaMultiSelector
                            selectedKey={filter.processed}
                            propertyName={compileNameOfProperty<IVlcportHistoricFilter>("processed")}
                            title={t("PROCESSED")}
                            onChange={onBooleanSelectorChange}
                        />
                    </div>
                    <div className={style.item}>
                        <BooleaMultiSelector
                            selectedKey={filter.withErrors}
                            propertyName={compileNameOfProperty<IVlcportHistoricFilter>("withErrors")}
                            title={t("WITH_ERROR")}
                            onChange={onBooleanSelectorChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <FilterHeader
            buttonColumn={true}
            content={content}
            onApply={onApply}
            onReset={onReset}
            height={120}
        />
    );
};
